export const useFormat = () => {
    // 1234 -> "1.2k", small numbers pass through unchanged.
    function formatCompact(n) {
        if (n == null) {
            return 0;
        }
        if (n >= 1000) {
            return (n / 1000).toFixed(1).replace(/\.0$/, "") + "k";
        }
        return n;
    }

    return {formatCompact};
};
